import React from 'react';

/**
 * Template 5: Tier List
 * S/A/B/C/D colored rows with items in each tier.
 * Person cutout on the right overlapping. Dark background.
 *
 * Inspired by: Funnel tier ranking thumbnail
 */
export default function JH_TierList({
  headline = '',
  personImage,
  bgColor = '#1a1a2e',
  accentColor = '#FFD700',
  tiers = [
    { rank: 'S', color: '#FF0000', items: ['Call Funnel', 'Challenge Funnel'] },
    { rank: 'A', color: '#FF6600', items: ['Book Funnel', 'Live Events'] },
    { rank: 'B', color: '#FFCC00', items: ['Auto Webinar', 'IG Shoutouts'] },
    { rank: 'C', color: '#33CC33', items: ['Mini Course'] },
    { rank: 'D', color: '#FF0000', items: ['Cold Email'] },
  ],
}) {
  const rowHeight = Math.min(120, Math.floor(680 / tiers.length));

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Inter', sans-serif",
    }}>
      {/* Tier rows */}
      <div style={{
        position: 'absolute', left: 0, top: 20, width: 880, zIndex: 1,
      }}>
        {tiers.map((tier, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', height: rowHeight,
            borderBottom: '2px solid rgba(255,255,255,0.1)',
          }}>
            {/* Rank label */}
            <div style={{
              width: 80, height: rowHeight, background: tier.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 48, fontWeight: 900, color: '#fff',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              flexShrink: 0,
            }}>{tier.rank}</div>

            {/* Items in tier */}
            <div style={{
              flex: 1, display: 'flex', alignItems: 'center', gap: 16,
              paddingLeft: 20, background: 'rgba(0,0,0,0.3)',
              height: '100%', overflow: 'hidden',
            }}>
              {tier.items.map((item, j) => (
                <span key={j} style={{
                  fontSize: 28, fontWeight: 700, color: '#fff',
                  whiteSpace: 'nowrap',
                }}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Person cutout - right side, overlapping */}
      {personImage ? (
        <div style={{
          position: 'absolute', right: 0, bottom: 0, width: 500, height: 720, zIndex: 2,
        }}>
          <img src={personImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 20, bottom: 0, width: 400, height: 620,
          background: 'rgba(255,255,255,0.06)', borderRadius: '12px 12px 0 0',
          zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 36, color: 'rgba(255,255,255,0.15)',
        }}>PHOTO</div>
      )}
    </div>
  );
}
